import type { BasketItem } from "../../../../models/BasketItem";
import type { AssortQuestion, BasketSurveyItem, SurveyAnswers, Survey2AssortSaver } from "../../../../models/Survey";
import {
  listSurveyQuestionsInDisplayOrder,
  parseIdentifiable,
  questionId,
  resolveSurveyAnswerForPayload,
} from "../../../../models/Survey";

export const buildAssortQuestionsForSurvey = (
  survey: Survey2AssortSaver,
  itemAnswers: Record<string, string>
): AssortQuestion[] => {
  const questions: AssortQuestion[] = [];
  for (const { section, question: q } of listSurveyQuestionsInDisplayOrder(survey)) {
    const sectionId = questionId(section);
    const qid = questionId(q);
    const stored = itemAnswers[qid] ?? "";
    const selectedOption = q.options?.find((opt) => questionId(opt) === stored);
    const statusRaw = selectedOption?.status ?? "A";
    const answerStatus = `${statusRaw}`.charAt(0) || "A";
    const answer = resolveSurveyAnswerForPayload(q, stored);
    questions.push({
      surveyIds: sectionId,
      question: q.question,
      answer,
      answerType: q.answerType,
      answerStatus,
    });
  }
  return questions;
};

export const buildSurveyAnswersEntry = (
  surveyItem: BasketSurveyItem,
  basketLine: BasketItem | undefined,
  itemAnswers: Record<string, string>
): SurveyAnswers => {
  const ta = basketLine?.ticketAccess ?? [];
  const access = ta[surveyItem.instanceIndex] ?? ta[0];
  const exerciseIdsRaw = access?.exerciseIds;

  return {
    assortIds: parseIdentifiable(basketLine?.assortIds),
    exerciseIds: parseIdentifiable(exerciseIdsRaw),
    questions: buildAssortQuestionsForSurvey(surveyItem.survey, itemAnswers),
  };
};
